/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const LinkedInBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M4.43 2C2.958 2 2 2.962 2 4.227c0 1.238.93 2.23 2.37 2.23h.03c1.494 0 2.424-.992 2.424-2.23C6.794 2.962 5.894 2 4.429 2ZM2.252 21.111H6.54V8.216H2.253V21.11Zm19.747 0v-7.394c0-3.961-2.112-5.804-4.935-5.804-2.277 0-3.294 1.253-3.865 2.13V8.216H8.912c.059 1.21 0 12.895 0 12.895H13.2V13.91c0-.386.03-.769.141-1.044.312-.771 1.018-1.569 2.2-1.569 1.553 0 2.17 1.183 2.17 2.916v6.9H22Zm-8.8-11.068v.042h-.03a.167.167 0 0 0 .03-.042Z" /></svg>);
const LinkedIn = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={LinkedInBase} {...rest} ref={ref} />);
export default LinkedIn;